import { Component } from '@angular/core';

type CallTypeId = 'branded' | 'nonbranded';

type Metric = {
  label: string;
  value: number;
  icon: 'trendingUp' | 'shield' | 'trendingDown' | 'alert';
};

type CallTypeData = {
  id: CallTypeId;
  label: string;
  title: string;
  description: string;
  image: string;
  metrics: Metric[];
  reasons: string[];
};

const CALL_DATA: Record<CallTypeId, CallTypeData> = {
  branded: {
    id: 'branded',
    label: 'Branded',
    title: 'Branded Calling',
    description:
      "Transform customer trust instantly. Display your company name, logo, and call reason before they answer. Answer rates soar when recipients recognize legitimate business calls.",
    image: 'assets/icip/9707faefeda9d44128dbb9bcd7749ad80dcabecd.png',
    metrics: [
      { label: 'Answer Rate', value: 87, icon: 'trendingUp' },
      { label: 'Trust Score', value: 94, icon: 'shield' },
    ],
    reasons: [
      '3x higher answer rates with instant brand recognition',
      'Eliminates spam perception and call blocking',
      'Close deals faster while competitors get ignored',
    ],
  },
  nonbranded: {
    id: 'nonbranded',
    label: 'Non-Branded',
    title: 'Non-Branded Calling',
    description:
      "Without branded caller ID, your calls appear as unknown numbers. Customers increasingly ignore or block these calls, assuming they're spam. Your sales team wastes time while competitors with branding reach customers first.",
    image: 'assets/icip/43c8b5ef710029224bd92a72ac66a55e244eb936.png',
    metrics: [
      { label: 'Answer Rate', value: 28, icon: 'trendingDown' },
      { label: 'Trust Score', value: 22, icon: 'alert' },
    ],
    reasons: [
      'Only 1 in 4 calls answered—your team wastes hours daily',
      'Flagged as spam, losing customers before you connect',
      'Competitors with branded calling win every time',
    ],
  },
};

@Component({
  selector: 'app-home-product-difference',
  standalone: false,
  templateUrl: './home-product-difference.component.html',
  styleUrl: './home-product-difference.component.scss',
})
export class HomeProductDifferenceComponent {
  activeType: CallTypeId = 'branded';

  get isBranded(): boolean {
    return this.activeType === 'branded';
  }

  get current(): CallTypeData {
    return CALL_DATA[this.activeType];
  }

  setActive(type: CallTypeId): void {
    this.activeType = type;
  }

  trackByMetricLabel(_idx: number, metric: Metric): string {
    return metric.label;
  }

  trackByReason(_idx: number, reason: string): string {
    return reason;
  }
}
